// get ecustomer list for admin workforce
export const RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER = "RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER";
export const ASSIGN_CUSTOMER_ACCOUNT_MANAGER = "ASSIGN_CUSTOMER_ACCOUNT_MANAGER";
export const ASSIGN_CUSTOMER_ACCOUNT_MANAGER_SUCCESS = "ASSIGN_CUSTOMER_ACCOUNT_MANAGER_success";
export const ASSIGN_CUSTOMER_ACCOUNT_MANAGER_FAILURE = "ASSIGN_CUSTOMER_ACCOUNT_MANAGER_failure";
